<template>
  <div class="image-upload">
    <!-- 图片预览 -->
    <div
      class="upload-one-component"
      :style="{width: width,height: height}"
      @click="$refs.fileInput.click()"
    >
      <img v-if="url" :src="url" class="upload-one-component-image" />
      <i v-else class="el-icon-plus upload-one-component-icon"></i>
    </div>

    <!-- 文件选择按钮 -->
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display:none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import { getS3UploadUrl } from "@/api/common";
import { guid } from "@/utils/index";

export default {
  name: "UploadAws",
  props: {
    url: {
      value: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "120px"
    },
    height: {
      type: String,
      default: "120px"
    }
  },
  model: {
    prop: "url", //绑定的值，通过父组件传递
    event: "update" //自定义时间名
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      // this.url = URL.createObjectURL(file);

      try {
        this.loading = true;

        const filename =  this.prefix + guid() + '.' + file.type.split('/')[1];

        // 调用后端接口获取上传地址
        const { data } = await getS3UploadUrl(filename, file.type);
        const { url } = data;

        // 上传到 S3
        await fetch(url, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type
          }
        });
        const fileUrl = data.host + '/' + filename;

        this.url = fileUrl;
        this.$emit("update", fileUrl);
      } catch (error) {
        console.error("上传失败", error);
        this.$emit("error", error);
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.upload-one-component {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .upload-one-component-icon {
    font-size: 60px;
    color: #8c939d;
    // width: 100%;
    // height: 100%;
    // align-items: center;
  }
  .upload-one-component-image {
    width: 100%;
    height: 100%;
    display: block;
  }
}
.upload-one-component:hover {
  border-color: #409eff;
}
</style>